import { IWindscreen } from "src/app/interfaces/interfaces";

export const requiredCharacters = 5;

export type SelectedPackages = {
  serviceForm?: any;
  troubleshootingForm?: any;
  wheelForm?: any;
  windscreenForm?: IWindscreen;
  techUpdateForm?: any;
  additionalPackagesForm?: any;
  timeSelectionForm?: any;
  other?: any;
};

export type ContactInformation = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  verifyEmail: string;
  discountCode: string;
  smsChecked: boolean;
  other: string;
  personalDataUsage: boolean;
};

export enum DiscountCodeValidationStateEnum {
  NotValidated,
  IsValidating,
  ValidationFailed,
  Validated
}

export interface IBookingError {
  title: string;
  subtitle: string;
  returnText: string;
  returnToPage: number;
  returnButtonAbove: boolean;
}
